import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { InView } from 'react-intersection-observer'
import { isEmpty } from '@sainsburys-tech/boltui-utils'
import { withCookies } from 'react-cookie'
import { getProductOptions } from './helpers/CarouselHelper'
import * as Styled from './Carousel.styles'

class Carousel extends Component {
  buildItemList = (parentPartNumber, productsInfo, itemsPerSlide) => {
    const { analyticsData, isNofollowLink } = this.props
    const options = getProductOptions(productsInfo, parentPartNumber, analyticsData)

    const items = options.map((option, key) => (
      <Styled.Link key={key} itemsPerSlide={itemsPerSlide}>
        <Styled.StyledProductCard
          {...option}
          featured={typeof option.citrusId !== 'undefined'}
          productLinkOverride={option.href}
          data-test='alternatives-product-card'
          badge={option.badge}
          mto={option.madeToOrder}
          isNofollowLink={
            isNofollowLink &&
            typeof option.partNumber === 'string' &&
            option.partNumber
              .trim()
              .toLowerCase()
              .startsWith('tuc')
          } // nofollow for Tu products only
          onClick={() => option.onClick()}
        />
      </Styled.Link>
    ))
    return items
  }

  render() {
    const {
      parentPartNumber,
      alternativesInfoList,
      onViewportChange,
      onSlideChanged,
      onSliderLoaded,
      onSliderUpdated,
      refFun,
      itemsPerSlide
    } = this.props

    if (isEmpty(alternativesInfoList)) {
      return null
    }
    const items = this.buildItemList(parentPartNumber, alternativesInfoList, itemsPerSlide)
    const options = {
      ...itemsPerSlide,
      items,
      ref: refFun,
      slideClass: 'carousel__slide',
      onSlideChanged,
      onSliderLoaded,
      onSliderUpdated,
      tabFocusable: false,
      innerAlignment: 'flex-start'
    }
    return (
      <InView as='div' onChange={onViewportChange} threshold={0.5} triggerOnce>
        <Styled.StyledSlider {...options} />
      </InView>
    )
  }
}

Carousel.propTypes = {
  parentPartNumber: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  itemsPerSlide: PropTypes.shape({
    itemsPerSlideXs: PropTypes.number,
    itemsPerSlideSm: PropTypes.number,
    itemsPerSlideMd: PropTypes.number,
    itemsPerSlideLg: PropTypes.number
  }),
  isNofollowLink: PropTypes.bool,
  analyticsData: PropTypes.object
}
export { Carousel as Component }

export default withCookies(Carousel)
